import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Divider } from '@pets-ui/Divider/Divider'
import { CartOutlined } from '@pets-ui/icons'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'

export const DIALOG_ORDER_DETAIL = 'DIALOG_ORDER_DETAIL'

export interface DialogOrderDetailProps {
  handleCheckout: () => void
  actionButtonText?: string
}

export const DialogOrderDetail = () => {
  const { open, closeDialog, handleCheckout, actionButtonText } = useDialog<DialogOrderDetailProps>(DIALOG_ORDER_DETAIL)
  const { campaignId, currency, campaignCode, countryCode } = useContextCampaignCart()
  const { destructuredData: campaignCouponCalculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)

  return (
    <ResponsiveDialog
      open={open}
      onClose={closeDialog}
      fullWidth
    >
      <DialogHeader title="明細" onClose={closeDialog} />
      <OrderDetail
        discountItems={campaignCouponCalculateResult?.discount_items || []}
        shippingTotal={campaignCouponCalculateResult?.shipping_total ?? 0}
        total={campaignCouponCalculateResult?.total ?? 0}
        subtotal={campaignCouponCalculateResult?.subtotal ?? 0}
        subtotalAfterDiscount={campaignCouponCalculateResult?.total_without_addon_v2 ?? 0}
        tax={campaignCouponCalculateResult?.tax ?? 0}
        currency={currency || 'TWD'}
        countryCode={countryCode}
        addonV2Total={campaignCouponCalculateResult?.addon_v2_total ?? 0}
        addonV2TotalBeforeDiscount={campaignCouponCalculateResult?.addon_v2_total_before_discount ?? 0}
      />
      <Divider />
      <DialogActions>
        <Button onClick={handleCheckout} startIcon={<CartOutlined />}>
          {actionButtonText || '前往結帳'}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
